import type { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function Layout({ children }: { children: ReactNode }) {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/login");
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="font-semibold text-gray-900">
            ヒートマップ管理画面
          </Link>
          {isAuthenticated && (
            <div className="flex items-center gap-4 text-sm text-gray-600">
              {user?.email && <span>{user.email}</span>}
              <button
                type="button"
                onClick={handleLogout}
                className="rounded border border-gray-300 px-3 py-1 hover:bg-gray-100"
              >
                ログアウト
              </button>
            </div>
          )}
        </div>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
